import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 抑制 NavigationDuplicated 错误（点击当前页导航时不报错）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return
    throw err
  })
}

const routes = [
  { path: '/',            component: () => import('../views/Cover.vue') },
  { path: '/login',       component: () => import('../views/Login.vue') },
  { path: '/register',    component: () => import('../views/Register.vue') },
  { path: '/role',        component: () => import('../views/RoleSelect.vue') },
  { path: '/home',        component: () => import('../views/Home.vue') },
  { path: '/workbench/alumni',  component: () => import('../views/workbench/AlumniHome.vue') },
  { path: '/workbench/teacher', component: () => import('../views/workbench/TeacherHome.vue') },
  { path: '/workbench/dept',    component: () => import('../views/workbench/DeptHome.vue') },
  { path: '/profile/alumni',    component: () => import('../views/profile/AlumniProfile.vue') },
  { path: '/profile/teacher',   component: () => import('../views/profile/TeacherProfile.vue') },
  { path: '/profile/dept',      component: () => import('../views/profile/DeptProfile.vue') },
  { path: '/publish/demand',      component: () => import('../views/publish/PublishDemand.vue') },
  { path: '/publish/capability',  component: () => import('../views/publish/PublishCapability.vue') },
  { path: '/publish/success',     component: () => import('../views/publish/SubmitSuccess.vue') },
  { path: '/search',             component: () => import('../views/search/SearchAll.vue') },
  { path: '/search/:code',       component: () => import('../views/search/SearchCategory.vue') },
  { path: '/detail/:type/:id',   component: () => import('../views/detail/PublicationDetail.vue') },
  { path: '/audit',              component: () => import('../views/audit/AuditDashboard.vue') },
  { path: '/audit/list',         component: () => import('../views/audit/AuditList.vue') },
  { path: '/audit/detail/:id',   component: () => import('../views/audit/AuditDetail.vue') },
  { path: '/audit/pass',         component: () => import('../views/audit/AuditPass.vue') },
]

const router = new VueRouter({ routes })

// 路由守卫
router.beforeEach((to, from, next) => {
  const publicPages = ['/', '/login', '/register', '/search', '/home', '/role']
  const isPublic = publicPages.includes(to.path) || to.path.startsWith('/search/') || to.path.startsWith('/detail/')
  const token = localStorage.getItem('alumni_token')
  if (!isPublic && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
